<template>
  <!-- 提款申请页面 -->
  <div id="withdrawalRequest">
    <Form
      :model="form"
      :rules="rules"
      v-model="regular"
    >
      <Input
        class="temr"
        label="企业名称"
        :readonly="true"
        v-model="form.corpName"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="借款人姓名"
        v-model="form.borrowerName"
        :readonly="true"
        :labelWidth="labelWidth"
      />

      <div class="company">
        <DrawAmtInput
          class="temr"
          :placeholder="placeholderDrawAmt"
          v-model="form.drawAmt"
          :reg="rules.drawAmt"
          :labelWidth="labelWidth"
          :ispayLimit="form.usableAmount"
          label="申请金额"
        />
        <span>元</span>
      </div>
      <SelfSelect
        label="申请期限"
        placeholder="请选择申请期限"
        v-model="form.term"
        @selectValues="selectValues"
        :columnsTerm="form.loanTermMap"
        :labelWidth="labelWidth"
      />
      <SelfSelect
        label="支付方式"
        placeholder="请选择支付方式"
        v-model="form.payment"
        :columnsTerm="form.paymentMap"
        defaultValue='0'
        :labelWidth="labelWidth"
      />
      <!-- <div v-if="form.payment === '0'" class="company">
         <Input
          class="temr"
          label="自主支付限额"
          v-model="form.selfPaymentLimit"
          :readonly="true"
          :labelWidth="labelWidth"
        />
        <span>元</span>
       </div>
       <div v-else>
        <AccountSelect
          label="放款账户名称"
          placeholder="请选择受托支付对象账户名称"
          v-model="form.custName"
          :getSelect="getSelect"
          :columnsTerm="custNameList"
          :labelWidth="labelWidth"
        />
       </div> -->
      <SelfSelect
        label="还款方式"
        placeholder="请选择还款方式"
        v-model="form.rtnTypes"
        :columnsTerm="form.columnsTermMethod"
        :labelWidth="labelWidth"
      />
      <SelfSelect
        label="对公账户标志"
        placeholder="请选择对公账户标志"
        v-model="form.corporateAccount"
        :columnsTerm="form.corporateAccountType"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="贷款入账账号"
        maxlength="32"
        placeholder="请输入贷款入账账号"
        v-model="form.loanBankNo"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="入账账户名称"
        placeholder="请输入入账账户名称"
        v-model="form.loanBankName"
        maxlength="50"
        :labelWidth="labelWidth"
      />

      <!-- 对公账户标志为本行账户时隐藏该字段 -->
      <div v-if="form.corporateAccount && form.corporateAccount !== '0'">
        <SelectInput
          label="开户行名称"
          class="temr"
          v-model="form.openBankName"
          @getOpenBankInfo="getOpenBankInfo"
          :maxlength="50"
          labelWidth="129px"
          placeholder="请输入开户行名称"
        />
        <Input
          class="temr"
          label="开户行行号"
          placeholder="请输入开户行行号"
          v-model="form.openBankNo"
          maxlength="20"
          :labelWidth="labelWidth"
        />
      </div>

      <Input
        class="temr"
        label="贷款还款账号"
        placeholder=""
        v-model="form.rePayAcctNumber"
        :readonly="true"
        :labelWidth="labelWidth"
      />
      <Input
        class="temr"
        label="还款账户名称"
        placeholder=""
        v-model="form.rePayAcctName"
        :readonly="true"
        :labelWidth="labelWidth"
      />

      <Input
        class="temr"
        label="手机号码"
        v-model="form.borrowerPhone"
        :readonly="true"
        :labelWidth="labelWidth"
      />
      <OwnMessageCode
        v-model="form.captcha"
        :reg="rules.captcha"
        label="短信验证码"
        :params="{
          orderId: form.orderId,
          smsUrl: form.smsUrl,
          phone: form.borrowerPhone,
          type: '5'
        }"
        :labelWidth="labelWidth"
      />
    </Form>
    <SelfButton
      :loading="loading"
      loadingText="提交中..."
      text="提交"
      type="danger"
      :disabled="!isDisabled"
      class="nextStep"
      :click="submitWithdrawalInfo"
    />
    <server-bank
      :productId="this.$route.query.productId"
      :isRelative="true"
    ></server-bank>

    <self-popup
      v-model="showContent"
      @define="define"
    ></self-popup>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
// import { milliFormat } from '@/utils';
import ServerBank from '@/components/ServerBank.vue';
import { Toast } from 'vant';
import DrawAmtInput from './components/DrawAmtInput.vue';
import AccountSelect from './components/AccountSelect.vue';
import OwnMessageCode from './components/MessageCode.vue';
import SelectInput from './components/SelectInput.vue';
import SelfSelect from './components/SelfSelect.vue';

export default {
  name: 'withdrawalRequest',
  components: {
    DrawAmtInput,
    AccountSelect,
    OwnMessageCode,
    SelectInput,
    SelfSelect,
    ServerBank,
  },
  data() {
    return {
      labelWidth: '129px',
      loading: false,
      form: {
        orderId: this.$route.query.orderId,
        corpName: '', // 企业名称
        borrowerName: '', // 借款人姓名
        drawAmt: '', // 申请金额
        term: '', // 申请期限
        payment: '0', // 支付方式
        rtnTypes: '', // 还款方式
        corporateAccount: '', // 对公账户标志 1本行 2他行
        borrowerPhone: '', // 银行预留手机号
        captcha: '', // 短信验证码
        // selfPaymentLimit: '', // 自主支付限额
        // selfPaymentLimitNumber: '',
        custName: '', // 放款账户名称
        loanBankNo: '', // 贷款入账账号
        loanBankName: '', // 贷款入账账户名称
        openBankNo: '', // 开户行行号
        openBankName: '', // 开户行名称
        rePayAcctNumber: '', // 账户账号
        rePayAcctName: '', // 账号名称
      },
      // usableAmount: '', // 剩余可提款额
      // showAccountDetails: false, // TODO-YXF 字段无注释
      // custNameList: [], // 账户名数组 -- 没用到
      // taxNo: '', // TODO-YXF 字段待确认
      showContent: '',
      regular: false,
      rules: {
        term: [{ required: true }],
        payment: [{ required: true }],
        rtnTypes: [{ required: true }],
        drawAmt: [
          {
            pattern: /^[1-9]\d{0,}$/,
            message: '申请金额格式输入有误,只能输入不以0开头的整数',
          },
        ],
        corporateAccount: [{ required: true }],
        loanBankNo: [{ required: true }],
        loanBankName: [{ required: true }],
        captcha: [{ pattern: /^\d{6}$/, message: '请输入6位数字的验证码' }],
      },
    };
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
    isDisabled() {
      const {
        drawAmt,
        usableAmount,
      } = this.form;
      if (parseInt(drawAmt || 0, 10) > parseInt(usableAmount, 10)) {
        return false;
      }
      return this.regular;
    },
    placeholderDrawAmt() {
      return `剩余可提款额${this.form.usableAmount || ''}`;
    },
  },
  mounted() {
    this.getWithdrawalInfo(); // 获取页面反显信息
  },
  watch: {
    'form.corporateAccount': {
      handler(val) {
        // 对公账户标志为本行账户时隐藏该字段, 则取消校验 (两处判断了该状态为0情况，如修改需要同时修改)
        if (val === '1') {
          // 更新form校验
          const t = this.form.openBankNo;
          this.form.openBankNo = '';
          setTimeout(() => {
            this.form.openBankNo = t;
          }, 100);
          this.rules.openBankNo = [{ required: true }];
          this.rules.openBankName = [{ required: true }];
        } else {
          delete this.rules.openBankNo;
          delete this.rules.openBankName;
        }
      },
    },
  },
  methods: {
    ...mapMutations('commonForms', ['updateForm']),

    // 获取页面反显信息
    async getWithdrawalInfo() {
      const { data } = await this.$api.OtherPage.queryEchoInfo({
        orderId: this.$route.query.orderId,
      });

      //   // 页面反显测试数据 TODO-YXF
      //   let data2 = {
      //   "success": true,
      //   "returnCode": "200",
      //   "returnMessage": "成功",
      //   "data": {
      //     "rePayAcctNumber": "181038016228951473",
      //     "columnsTermMethod": [
      //       {
      //         "text": "等额本息",
      //         "value": "3"
      //       }
      //     ],
      //     "loanTermMap": [
      //       {
      //         "termOptCode": "20200821151140939275",
      //         "text": "6个月",
      //         "value": "6",
      //         "termUnit": "M"
      //       },
      //       {
      //         "termOptCode": "20200821151140938275",
      //         "text": "9个月",
      //         "value": "9",
      //         "termUnit": "M"
      //       },
      //       {
      //         "termOptCode": "20200821151140937275",
      //         "text": "12个月",
      //         "value": "12",
      //         "termUnit": "M"
      //       }
      //     ],
      //     "smsUrl": "/loan/supermarket/sendSmsCode/v1.0",
      //     "borrowerPhone": "15732054071",
      //     "borrowerName": "魏冬冬",
      //     "corpName": "深圳市泽安信息咨询有限公司",
      //     "rePayAcctName": "深圳市泽安信息咨询有限公司还款专户",
      //     "acctStatue": null,
      //     "paymentMap": [
      //       {
      //         "text": "自主支付",
      //         "value": "0"
      //       }
      //     ],
      //     "usableAmount": "10000.00",
      //     "acctType": "1",
      //     "corporateAccountType": [
      //       {
      //         "text": "苏宁账户",
      //         "value": "0"
      //       },
      //       {
      //         "text": "他行张户",
      //         "value": "1"
      //       }
      //     ]
      //   }
      // }.data;
      this.form = {
        ...this.form,
        ...data,
      };
    },

    // 提款提交
    async submitWithdrawalInfo() {
      try {
        const { success, returnMessage } = await this.$api.OtherPage.commitApply(this.form);
        if (success) {
          this.$store.dispatch('otherPages/jumpCurrPageServer');
        } else {
          this.showContent = returnMessage;
        }
      } catch (e) {
        Toast('提款提交失败');
      }
    },

    // 申请期限选择器form赋值，如字段量大可采用解构赋值
    selectValues(e) {
      this.form.termOptCode = e.termOptCode;
      this.form.termUnit = e.termUnit;
    },

    // 开户行名称模糊查询及开户行行号自动反显
    getOpenBankInfo(e) {
      this.form = {
        ...this.form,
        ...e,
      };
    },

    // 点确定跳转下一页面
    define(obj) {
      this.$store.dispatch('otherPages/jumpCurrPageServer');
      obj.cb && obj.cb();
    },
  },
};
</script>
<style scoped>
#withdrawalRequest {
  width: 100%;
  height: 100%;
  background: #fff;
}
#withdrawalRequest >>> .van-field__label {
  width: 129px;
  margin-right: 0;
  color: #1c2438;
}
.temr::after {
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
#withdrawalRequest >>> .van-button--disabled {
  opacity: 1;
  color: #fff;
  background-color: #bac8d1 !important;
  border: 1px solid #bac8d1 !important;
}
.mt8 {
  padding-top: 8px;
}
.nextStep {
  margin-top: 30px;
  margin-bottom: 12px;
}
.getCode {
  color: rgba(246, 82, 73, 1);
  font-weight: 400;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.code_btn {
  position: absolute;
  right: 14px;
  bottom: 7px;
  z-index: 3;
  width: auto;
  height: 35px;
  background: #fff;
  border: none;
}
.company {
  position: relative;
}
.company > span {
  position: absolute;
  top: 12px;
  right: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
}
.company >>> .cross {
  margin-right: 38px;
}
</style>
